// FrontEnd/src/hooks/useConfiguracion.js

import { useState, useEffect } from 'react';
import API from '../services/api';

const useConfiguracion = () => {
    const [configuracion, setConfiguracion] = useState({
        NombreEmpresa: ''
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const cargarConfiguracion = async () => {
            try {
                const response = await API.get('/config/empresa');
                setConfiguracion(response.data);
            } catch (error) {
                console.error('Error al cargar configuración:', error);
                // No establecemos un nombre por defecto para no mostrar nada si falla
                setConfiguracion({ NombreEmpresa: '' });
            } finally {
                setLoading(false);
            }
        };

        cargarConfiguracion();
    }, []);

    return { configuracion, loading };
};

export default useConfiguracion;